import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useNuxtApp } from '#app'
import { container } from '~~/apps/top-destinations/inversify.config'
import { TopDestinationsRepository } from '~~/apps/top-destinations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopDestinations',
  setup(__props) {

const { $route } = useNuxtApp()
const lang = $route.params.lang || 'en-gb'
const { data: destinations } = useLazyAsyncData(
  `destinations-${lang}`,
  async () => {
    const destinationsRepository = container.get(TopDestinationsRepository)
    return destinationsRepository.getAll(lang)
  },
)

return { __sfc: true,$route, lang, destinations }
}

})